import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';

const TermsAndConditions: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - Toppers Buddy | Class 10 Science Notes</title>
        <meta name="description" content="Read the terms and conditions for using Toppers Buddy Class 10 Science handwritten notes." />
      </Helmet>
      
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        
        <main className="flex-1 container px-4 md:px-6 py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-center mb-8">Terms & Conditions</h1>
            
            <div className="bg-card rounded-xl border border-border p-8 shadow-sm prose prose-sm max-w-none">
              <p className="text-muted-foreground mb-6">
                Last updated: December 2024
              </p>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
                <p className="text-muted-foreground">
                  Welcome to Toppers Buddy. By accessing and using our website and services, you agree to be bound by these Terms and Conditions. Please read them carefully before making any purchase.
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">2. Products and Services</h2>
                <p className="text-muted-foreground">
                  Toppers Buddy provides Class 10 Science handwritten notes in digital format (PDF). Our notes cover all 13 chapters of the CBSE Class 10 Science curriculum for the academic year 2025-2026.
                </p>
                <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
                  <li>Product: Class 10 Science Handwritten Notes (Digital PDF)</li>
                  <li>Price: ₹149 (inclusive of all taxes)</li>
                  <li>Delivery: Instant digital access after successful payment</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">3. User Accounts</h2>
                <p className="text-muted-foreground">
                  To purchase our notes, you must create an account with valid information including your full name, email address, and mobile number. You are responsible for maintaining the confidentiality of your account credentials.
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">4. Payment Terms</h2>
                <p className="text-muted-foreground">
                  All payments are processed securely through Cashfree payment gateway. We accept UPI, debit cards, credit cards, and net banking. All prices are displayed in Indian Rupees (INR).
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">5. Intellectual Property</h2>
                <p className="text-muted-foreground">
                  All content, including handwritten notes, is the intellectual property of Toppers Buddy. Purchasing our notes grants you a personal, non-transferable license to use them for your educational purposes only. You may not redistribute, resell, or share the notes with others.
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">6. Prohibited Activities</h2>
                <ul className="list-disc list-inside text-muted-foreground space-y-1">
                  <li>Sharing your account credentials with others</li>
                  <li>Redistributing or reselling purchased notes</li>
                  <li>Using automated systems to access our services</li>
                  <li>Attempting to circumvent security measures</li>
                </ul>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">7. Limitation of Liability</h2>
                <p className="text-muted-foreground">
                  Toppers Buddy provides study materials to supplement your learning. We do not guarantee specific exam results. Our notes are meant to aid preparation and should be used alongside official textbooks and classroom learning.
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">8. Changes to Terms</h2>
                <p className="text-muted-foreground">
                  We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the new terms.
                </p>
              </section>
              
              <section className="mb-6">
                <h2 className="text-xl font-semibold mb-3">9. Contact Information</h2>
                <p className="text-muted-foreground">
                  For any questions regarding these terms, please contact us at:<br />
                  Email: toppersbuddy2@gmail.com<br />
                  WhatsApp: +91 7022174299
                </p>
              </section>
            </div>
          </div>
        </main>
        
        <Footer />
        <WhatsAppButton />
      </div>
    </>
  );
};

export default TermsAndConditions;
